import { HamburgerPlusIcon } from './HamburgerPlusIcon';

/**
 * author: Colton Wiscombe
 * id AD90D2EE-E142-45C3-977E-4D8299E12930
 * name hamburger-plus
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hamburger-plus.svg
 * tags
 * - Food / Drink 
 */
export const BurgerPlusIcon = HamburgerPlusIcon;
export default BurgerPlusIcon